<img [src]="src"
  [srcset]="srcset"
  [sizes]="sizes"
  [attr.loading]="loading"
  [ngStyle]="imgStyle">